import Button from '@/presentation/components/elements/Button';
import { useModalContext } from '@/presentation/context/modal';
import { useTranslations } from 'use-intl';

interface PositionFeeButtonsProps {
  showClaimFeesButton: boolean;
}

export const PositionFeeButtons = ({
  showClaimFeesButton,
}: PositionFeeButtonsProps) => {
  const t = useTranslations('Profile.Positions');
  const { showCreatePositionModal, showClaimRewardsModal } = useModalContext();

  return (
    <aside className="md:ml-auto md:pl-6 flex items-center space-x-2 mt-4 md:mt-0">
      {showClaimFeesButton && (
        <Button className="flex-none" onClick={() => showClaimRewardsModal({})}>
          {t('actions.claim')}
        </Button>
      )}
      <button
        className="text-pink-500 font-medium hover:underline px-2"
        onClick={() => showCreatePositionModal({})}
      >
        {t('actions.new')}
      </button>
    </aside>
  );
};
